module.exports = __webpack_public_path__ + "static/media/up-arrow.e982a2d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/up-arrow.svg
// module id = 785
// module chunks = 0